import { useAuth0 } from '@auth0/auth0-react';
import { CircularProgress } from "@material-ui/core";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import Button from 'components/button/Button';
import { LabelField } from 'components/LabelField';
import MyButton from 'components/MyButton/index';
import UserService from "Lib/API/users/index";
import React, { useEffect, useState } from 'react';
import { toastr } from 'react-redux-toastr';
import Select, { components } from "react-select";
import { AddNotifyActions, AddNotifyActionsBtn, AddNotifyContainer, AddNotifyContent, AddNotifyFormGroup, AddNotifyTitle } from './Theme';
import Wysiwyg from './Wysiwyg';


const selectControlStyles = {
  backgroundColor: "#F3F6F9",
  borderColor: "#F3F6F9",
  color: "#3F4254",
  transition:
    "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
  paddingTop: "6px",
  paddingBottom: "6px",
  cursor: "pointer",
};
const colourStyles = {
  control: (styles) => ({
    ...styles,
    ...selectControlStyles,
  }),
  menu: (styles) => ({
    ...styles,
    zIndex: 9999,
  }),
};

const formatOptionLabel = ({ label, _id }) => {
  return (
    <div className="dropdown-container" key={_id}>
      <div className="icon-name-container d-flex align-items-center justify-content-start">
        <div className="name-container" style={{ marginInlineStart: 10 }}>
          <div>{label}</div>
        </div>
      </div>
    </div>
  );
};

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <BottomArrowSvg label="Emoji" />
    </components.DropdownIndicator>
  );
};


const AddNotify = ({onClose}) => {
  const { getAccessTokenSilently } = useAuth0();

  const [loading, setLoading] = useState(false);
  const [userList, setUserList] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [message, setMessage] = useState("");
  const [addLoading, setAddLoading] = useState(false);

  const getUsersHandler = async (e) => {
    setLoading(true);
    const token = await getAccessTokenSilently();

    await UserService.getAllUsers(token).then((res) => {
      const result = res?.payload?.data;
      const formatUsers = result?.map((item) => {
        return {
          label: item?.name,
          value: item._id,
        }
      })
      setUserList(formatUsers);
      setLoading(false);
    })
      .catch((err) => {
        setLoading(false);
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setLoading(false);
      });
  };


  useEffect(() => {
    getUsersHandler();
  }, []);


  const addNotifyHandler = async() => {
    setAddLoading(true);
    const token = await getAccessTokenSilently();

    const payload = {
      assignTo: selectedUsers?.map(user => user?.value),
      message: message,
    }

    UserService.sendNotification({token, body: payload})
      .then(res => {
        onClose(true);
        toastr.success('Notification sent successfully');
      })
      .catch(err => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setAddLoading(false);
      });
  }



  return (
    <AddNotifyContainer>
      <AddNotifyTitle>Notify</AddNotifyTitle>
      <AddNotifyContent>
        <AddNotifyFormGroup className="form-group">
          <LabelField mandatory title={"Select Users"} />
          <Select
            {...{
              name: `users`,
              checkValidation: false,
            }}
            isMulti={true}
            classNamePrefix="react-select"
            formatOptionLabel={formatOptionLabel}
            options={userList}
            isLoading={loading}
            styles={colourStyles}
            onChange={(value) => {
              setSelectedUsers(value);
            }}
            value={selectedUsers}
            components={{ DropdownIndicator }}
          />
        </AddNotifyFormGroup>
        <AddNotifyFormGroup>
          <LabelField
            title="Message"
          />
          <Wysiwyg setMessage={setMessage} message={message} />
        </AddNotifyFormGroup>
        <AddNotifyActions className="d-flex justify-content-end mt-8" style={{ gap: "20px" }}>
          <AddNotifyActionsBtn className="saveBtn-drawer">
            <Button
              onClick={() => onClose()}
              variant="primary-outline"
              size="md"
            >
              <span>Close</span>
            </Button>
          </AddNotifyActionsBtn>
          <AddNotifyActionsBtn className="saveBtn-drawer">
             <Button
              onClick={addNotifyHandler}
              disabled={addLoading || selectedUsers.length === 0 || !message}
              variant="primary"
              size="md"
            >
              {
                addLoading ? (
                  <div className="d-flex align-items-center justify-content-center">
                    <CircularProgress
                      size={20}
                      style={{
                        color: "#ffffff",
                      }}
                    />
                  </div>
                ) : (
                  "Add"
                )
              }
            </Button>
          </AddNotifyActionsBtn>
        </AddNotifyActions>
      </AddNotifyContent>
    </AddNotifyContainer>
  )
}

export default AddNotify